import { getVocabularyBookApi } from "@/api/services/admin/learning-content";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { useQuery } from "@tanstack/react-query";

/**
 * Custom hook for fetching vocabulary book data by industry ID.
 * Returns null data gracefully when no vocabulary book exists (404).
 */
export const useVocabularyBook = (industryId?: string) => {
  const isValidId = Boolean(industryId) && /^\d+$/.test(industryId!);

  const query = useQuery({
    queryKey: [QUERY_KEYS.LEARNING_CONTENT.FETCH_VOCABULARY_BOOK, industryId],
    queryFn: () => getVocabularyBookApi(industryId!),
    enabled: isValidId,
    retry: (failureCount, error) => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const status = (error as any)?.response?.status;
      if (status === 404) return false;
      return failureCount < 3;
    },
  });

  return {
    data: query.data?.data ?? null,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
};
